import React from "react";
import { SVG } from "../Base/index";

const lenndSVGs = {
  az: ({ otherTags = null, ...svgProps }) => (
    <SVG {...svgProps} width="14" height="14" viewBox="0 0 14 14" fill="none">
      {otherTags}
      <path
        d="M8.95974 2.10458H5.81307L7.38641 0.53125L8.95974 2.10458ZM5.83307 11.9113H8.93974L7.38641 13.4646L5.83307 11.9113ZM3.06641 3.17792L0.0664062 10.8179H1.29307L1.90641 9.18458H5.31307L5.92641 10.8179H7.15307L4.15974 3.17792H3.06641ZM2.31307 8.09125L3.60641 4.63792L4.89974 8.09125H2.31307ZM9.48641 9.75792H13.5664V10.8179H7.87974V9.95792L11.8264 4.25125H7.90641V3.18458H13.4397V4.02458L9.48641 9.75792Z"
        fill="#494949"
      />
    </SVG>
  ),
  circle: ({ otherTags = null, ...svgProps }) => (
    <SVG {...svgProps} stroke="currentColor" viewBox="0 0 48 48">
      {otherTags}
      <circle cx="24" cy="24" r="18" strokeWidth="3" fill="none" />
    </SVG>
  ),
  circleHalfFilled: ({ otherTags = null, ...svgProps }) => (
    <SVG {...svgProps} stroke="currentColor" viewBox="0 0 48 48">
      {otherTags}
      <circle cx="24" cy="24" r="18" strokeWidth="3" fill="none" />
      <g transform="matrix(1,0,0,1,6,6)">
        <path d="M36,18.116C35.937,27.997 27.896,36 18,36C8.066,36 0,27.934 0,18L36,18L36,18.116Z" />
      </g>
    </SVG>
  ),
  drag: ({ otherTags = null, ...svgProps }) => (
    <SVG {...svgProps} viewBox="0 0 48 48">
      {otherTags}
      <g transform="matrix(1,0,0,1,0,0)">
        <g transform="matrix(0.75,0,0,0.75,21,-3)">
          <circle cx="12" cy="12" r="4" />
        </g>
        <g transform="matrix(0.75,0,0,0.75,9,-3)">
          <circle cx="12" cy="12" r="4" />
        </g>
        <g transform="matrix(0.75,0,0,0.75,21,9)">
          <circle cx="12" cy="12" r="4" />
        </g>
        <g transform="matrix(0.75,0,0,0.75,9,9)">
          <circle cx="12" cy="12" r="4" />
        </g>
        <g transform="matrix(0.75,0,0,0.75,21,21)">
          <circle cx="12" cy="12" r="4" />
        </g>
        <g transform="matrix(0.75,0,0,0.75,9,21)">
          <circle cx="12" cy="12" r="4" />
        </g>
        <g transform="matrix(0.75,0,0,0.75,21,33)">
          <circle cx="12" cy="12" r="4" />
        </g>
        <g transform="matrix(0.75,0,0,0.75,9,33)">
          <circle cx="12" cy="12" r="4" />
        </g>
      </g>
    </SVG>
  ),
  duplicate: ({ otherTags = null, ...svgProps }) => (
    <SVG {...svgProps} width="16" height="16" viewBox="0 0 16 16" fill="none">
      {otherTags}
      <path
        d="M11.0013 0.666504H3.0013C2.26797 0.666504 1.66797 1.2665 1.66797 1.99984V11.3332H3.0013V1.99984H11.0013V0.666504ZM13.0013 3.33317H5.66797C4.93464 3.33317 4.33464 3.93317 4.33464 4.6665V13.9998C4.33464 14.7332 4.93464 15.3332 5.66797 15.3332H13.0013C13.7346 15.3332 14.3346 14.7332 14.3346 13.9998V4.6665C14.3346 3.93317 13.7346 3.33317 13.0013 3.33317ZM13.0013 13.9998H5.66797V4.6665H13.0013V13.9998Z"
        fill="#494949"
      />
    </SVG>
  ),
  deleteOutline: ({ otherTags = null, ...svgProps }) => (
    <SVG {...svgProps} width="16" height="16" viewBox="0 0 16 16" fill="none">
      {otherTags}
      <path
        d="M3.9987 12.6667C3.9987 13.4 4.5987 14 5.33203 14H10.6654C11.3987 14 11.9987 13.4 11.9987 12.6667V4.66667H3.9987V12.6667ZM5.33203 6H10.6654V12.6667H5.33203V6ZM10.332 2.66667L9.66536 2H6.33203L5.66536 2.66667H3.33203V4H12.6654V2.66667H10.332Z"
        fill="#494949"
      />
    </SVG>
  ),
  editOutline: ({ otherTags = null, ...svgProps }) => (
    <SVG {...svgProps} width="16" height="16" viewBox="0 0 16 16">
      {otherTags}
      <path
        d="M9.37236 6.01333L9.98569 6.62667L3.94569 12.6667H3.33236V12.0533L9.37236 6.01333ZM11.7724 2C11.6057 2 11.4324 2.06667 11.3057 2.19333L10.0857 3.41333L12.5857 5.91333L13.8057 4.69333C14.0657 4.43333 14.0657 4.01333 13.8057 3.75333L12.2457 2.19333C12.1124 2.06 11.9457 2 11.7724 2ZM9.37236 4.12667L1.99902 11.5V14H4.49902L11.8724 6.62667L9.37236 4.12667Z"
        fill="#494949"
      />
    </SVG>
  ),
  eigthSizeDot: ({ otherTags = null, ...svgProps }) => (
    <SVG {...svgProps} viewBox="0 0 48 48">
      {otherTags}
      <g transform="matrix(0.75,0,0,0.75,3,3)">
        <circle cx="28" cy="28" r="4" />
      </g>
    </SVG>
  ),
  eigthSizeSquare: ({ otherTags = null, ...svgProps }) => (
    <SVG {...svgProps} viewBox="0 0 48 48">
      {otherTags}
      <g transform="matrix(0.125,0,0,0.125,21,21)">
        <rect x="0" y="0" width="48" height="48" />
      </g>
    </SVG>
  ),
  expand: ({ otherTags = null, ...svgProps }) => (
    <SVG {...svgProps} viewBox="0 0 48 48">
      {otherTags}
      <path d="M12,36L24,36L24,40L8,40L8,24L12,24L12,36Z" />
      <g transform="matrix(-1,0,0,-1,48,48)">
        <path d="M12,36L24,36L24,40L8,40L8,24L12,24L12,36Z" />
      </g>
    </SVG>
  ),
  expandVert: ({ otherTags = null, ...svgProps }) => (
    <SVG {...svgProps} viewBox="0 0 48 48">
      {otherTags}
      <g transform="matrix(0.707107,-0.707107,0.707107,0.707107,-9.94113,21)">
        <path d="M12,36L24,36L24,40L8,40L8,24L12,24L12,36Z" />
      </g>
      <g transform="matrix(-0.707107,0.707107,-0.707107,-0.707107,57.9411,27)">
        <path d="M12,36L24,36L24,40L8,40L8,24L12,24L12,36Z" />
      </g>
    </SVG>
  ),
  facebook: ({ otherTags = null, ...svgProps }) => (
    <SVG {...svgProps} width="20" height="20" viewBox="0 0 20 20" fill="none">
      {otherTags}
      <g id="Facebook">
        <rect width="20" height="20" rx="10" fill="#1877F2" />
        <path
          id="Vector"
          d="M13.8926 12.8906L14.3359 10H11.5625V8.125C11.5625 7.33398 11.9492 6.5625 13.1914 6.5625H14.4531V4.10156C14.4531 4.10156 13.3086 3.90625 12.2148 3.90625C9.92969 3.90625 8.4375 5.29102 8.4375 7.79688V10H5.89844V12.8906H8.4375V19.8789C8.94727 19.959 9.46875 20 10 20C10.5312 20 11.0527 19.959 11.5625 19.8789V12.8906H13.8926Z"
          fill="white"
        />
      </g>
    </SVG>
  ),
  filePdf: ({ otherTags = null, ...svgProps }) => (
    <SVG
      {...svgProps}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="24"
      viewBox="0 0 18 24"
      fill="none"
    >
      {otherTags}
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.14982 0H11.1738L17.9744 7.08846V20.8756C17.9744 22.6027 16.5771 24 14.8559 24H3.14982C1.42269 24 0.0253906 22.6027 0.0253906 20.8756V3.12443C0.0253603 1.3973 1.42266 0 3.14982 0Z"
        fill="#FA5252"
      />
      <path
        opacity="0.302"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.168 0V7.03449H17.9746L11.168 0Z"
        fill="white"
      />
      <path
        d="M3.49756 17.9071V13.5233H5.36263C5.8244 13.5233 6.19023 13.6492 6.46609 13.9071C6.74195 14.1589 6.87989 14.5008 6.87989 14.9266C6.87989 15.3523 6.74195 15.6942 6.46609 15.946C6.19023 16.2039 5.8244 16.3299 5.36263 16.3299H4.619V17.9071H3.49756ZM4.619 15.3763H5.2367C5.4046 15.3763 5.53654 15.3404 5.62651 15.2564C5.71645 15.1785 5.76445 15.0705 5.76445 14.9266C5.76445 14.7827 5.71648 14.6747 5.62651 14.5968C5.53657 14.5128 5.40463 14.4768 5.2367 14.4768H4.619V15.3763ZM7.34163 17.9071V13.5233H8.89486C9.2007 13.5233 9.48857 13.5652 9.75842 13.6552C10.0283 13.7451 10.2742 13.8711 10.49 14.045C10.706 14.2129 10.8799 14.4408 11.0058 14.7287C11.1257 15.0165 11.1917 15.3464 11.1917 15.7182C11.1917 16.084 11.1258 16.4138 11.0058 16.7017C10.8799 16.9895 10.706 17.2174 10.49 17.3853C10.2741 17.5592 10.0283 17.6852 9.75842 17.7751C9.48857 17.8651 9.2007 17.9071 8.89486 17.9071H7.34163ZM8.43909 16.9536H8.76292C8.93682 16.9536 9.09875 16.9356 9.24867 16.8936C9.39259 16.8516 9.53054 16.7856 9.66248 16.6957C9.78841 16.6057 9.89036 16.4798 9.96232 16.3119C10.0343 16.144 10.0703 15.946 10.0703 15.7182C10.0703 15.4843 10.0343 15.2864 9.96232 15.1185C9.89036 14.9506 9.78841 14.8246 9.66248 14.7347C9.53054 14.6447 9.39262 14.5787 9.24867 14.5368C9.09875 14.4948 8.93682 14.4768 8.76292 14.4768H8.43909V16.9536ZM11.7554 17.9071V13.5233H14.8739V14.4768H12.8769V15.1784H14.4721V16.126H12.8769V17.9071H11.7554Z"
        fill="white"
      />
    </SVG>
  ),
  fileZip: ({ otherTags = null, ...svgProps }) => (
    <SVG
      {...svgProps}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="24"
      viewBox="0 0 18 24"
      fill="none"
    >
      {otherTags}
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.14572 0H11.1728L17.9751 7.09007V20.8792C17.9751 22.5982 16.5733 24 14.8543 24H3.14572C1.41932 24 0.0249023 22.5982 0.0249023 20.8792V3.12082C0.0249023 1.39442 1.41932 0 3.14572 0Z"
        fill="#FAB005"
      />
      <path
        opacity="0.302"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.1655 0V7.03106H17.9752L11.1655 0Z"
        fill="white"
      />
      <path
        d="M6.63548 12.4685V10.8306C6.63548 10.6536 6.49529 10.5134 6.31823 10.5134H5.43289C5.25583 10.5134 5.11564 10.6536 5.11564 10.8306V12.4685L4.62133 13.9146C4.48114 14.3203 4.54755 14.7704 4.79839 15.1172C5.04186 15.4639 5.44763 15.6705 5.87556 15.6705C6.30349 15.6705 6.70189 15.4639 6.95273 15.1172C7.20357 14.7704 7.26998 14.3204 7.12979 13.9146L6.63548 12.4685ZM6.42891 14.7409C6.17807 15.1024 5.57308 15.1024 5.31487 14.7409C5.18945 14.5638 5.15255 14.3277 5.22632 14.1211L5.38865 13.6342H6.35513L6.52483 14.1211C6.59124 14.3277 6.5617 14.5638 6.42891 14.7409ZM3.91309 1.71904V2.61914C3.91309 2.79621 4.05327 2.93639 4.23034 2.93639H5.43292V4.27917H4.23034C4.05327 4.27917 3.91309 4.41935 3.91309 4.59642V5.28992C3.91309 5.46699 4.05327 5.61454 4.23034 5.61454H5.43292V6.94992H4.23034C4.05327 6.94992 3.91309 7.09011 3.91309 7.26717V7.96804C3.91309 8.14511 4.05327 8.28529 4.23034 8.28529H5.43292V9.30342C5.43292 9.48048 5.58048 9.62067 5.75754 9.62067H7.52085C7.69054 9.62067 7.83809 9.48048 7.83809 9.30342V8.60254C7.83809 8.43285 7.69054 8.28529 7.52085 8.28529H6.31089V6.94992H7.52085C7.69054 6.94992 7.83809 6.80973 7.83809 6.63267V5.93179C7.83809 5.75473 7.69054 5.61454 7.52085 5.61454H6.31089V4.27917H7.52085C7.69054 4.27917 7.83809 4.13161 7.83809 3.95455V3.26104C7.83809 3.08398 7.69054 2.93642 7.52085 2.93642H6.31089V1.71167C6.31086 1.71167 3.91309 1.71904 3.91309 1.71904Z"
        fill="white"
      />
    </SVG>
  ),
  fileWord: ({ otherTags = null, ...svgProps }) => (
    <SVG
      {...svgProps}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="24"
      viewBox="0 0 18 24"
      fill="none"
    >
      {otherTags}
      <path
        d="M3.1445 0H11.1768L17.9766 7.09058V20.8794C17.9766 22.6013 16.5779 24 14.8514 24H3.14453C1.42265 24 0.0239258 22.6013 0.0239258 20.8794V3.12061C0.0238955 1.39872 1.42262 0 3.1445 0Z"
        fill="#228AE6"
      />
      <path
        opacity="0.302"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.1675 0V7.03521H17.9765L11.1675 0Z"
        fill="white"
      />
      <path
        d="M12.1645 12.4871H5.83557C5.54473 12.4871 5.30469 12.2516 5.30469 11.9608C5.30469 11.67 5.54473 11.4346 5.83557 11.4346H12.1645C12.4553 11.4346 12.6907 11.67 12.6907 11.9608C12.6907 12.2516 12.4553 12.4871 12.1645 12.4871ZM10.0548 18.816H5.83557C5.54473 18.816 5.30469 18.5805 5.30469 18.2897C5.30469 17.9989 5.54473 17.7635 5.83557 17.7635H10.0548C10.3457 17.7635 10.5811 17.9989 10.5811 18.2897C10.5811 18.5805 10.3457 18.816 10.0548 18.816ZM12.1645 16.7063H5.83557C5.54473 16.7063 5.30469 16.4709 5.30469 16.1801C5.30469 15.8893 5.54473 15.6538 5.83557 15.6538H12.1645C12.4553 15.6538 12.6907 15.8893 12.6907 16.1801C12.6907 16.4709 12.4553 16.7063 12.1645 16.7063ZM12.1645 14.5967H5.83557C5.54473 14.5967 5.30469 14.3613 5.30469 14.0704C5.30469 13.7796 5.54473 13.5442 5.83557 13.5442H12.1645C12.4553 13.5442 12.6907 13.7796 12.6907 14.0704C12.6907 14.3613 12.4553 14.5967 12.1645 14.5967Z"
        fill="white"
      />
    </SVG>
  ),
  fileSvg: ({ otherTags = null, ...svgProps }) => (
    <SVG
      {...svgProps}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="24"
      viewBox="0 0 18 24"
      fill="none"
    >
      {otherTags}
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.14702 0H11.1772L17.9748 7.09195V20.8779C17.9748 22.6023 16.5771 24 14.8526 24H3.14702C1.42256 24 0.0249023 22.6023 0.0249023 20.8779V3.12212C0.0249023 1.39769 1.42256 0 3.14702 0Z"
        fill="#4DADF7"
      />
      <path
        opacity="0.302"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.1675 0V7.0337H17.9747L11.1675 0Z"
        fill="white"
      />
      <path
        d="M4.76782 16.798C4.33104 16.798 3.94604 16.6654 3.61927 16.3969C3.2925 16.1283 3.11456 15.7983 3.08545 15.4068L4.03665 15.1286C4.0593 15.3421 4.14342 15.5201 4.29871 15.6624C4.45078 15.8015 4.62224 15.8727 4.81637 15.8727C4.97815 15.8727 5.10754 15.8371 5.20785 15.7659C5.30492 15.6948 5.35668 15.6042 5.35668 15.4877C5.35668 15.3939 5.31462 15.313 5.23696 15.245C5.1593 15.1803 5.05578 15.1253 4.93284 15.0865C4.80667 15.0444 4.6643 15.0024 4.51225 14.9603C4.35696 14.9215 4.20164 14.8665 4.0496 14.8018C3.89752 14.7338 3.75843 14.6562 3.63225 14.5656C3.50607 14.475 3.40255 14.3488 3.32489 14.1838C3.24723 14.022 3.20841 13.8311 3.20841 13.6111C3.20841 13.2585 3.36049 12.9608 3.66136 12.7247C3.96548 12.4885 4.3311 12.3688 4.76139 12.3688C5.18523 12.3688 5.5573 12.4723 5.87113 12.6794C6.18819 12.8832 6.38554 13.155 6.4632 13.4882L5.47319 13.9023C5.42788 13.7179 5.34376 13.5691 5.21759 13.4623C5.09465 13.3523 4.94258 13.2974 4.76139 13.2974C4.62227 13.2974 4.51228 13.3233 4.43138 13.3815C4.3505 13.4365 4.30844 13.5109 4.30844 13.6047C4.30844 13.6985 4.36345 13.773 4.47022 13.828C4.57699 13.8862 4.70963 13.9283 4.86816 13.9574C5.0267 13.9833 5.20139 14.0286 5.38582 14.09C5.57347 14.1515 5.74495 14.2259 5.90348 14.3197C6.06202 14.4103 6.19465 14.5527 6.30142 14.7468C6.40819 14.9442 6.4632 15.1803 6.4632 15.4554C6.4632 15.8565 6.30791 16.1801 5.99731 16.4292C5.68342 16.6751 5.27578 16.798 4.76782 16.798ZM8.05818 16.7495L6.5311 12.4174H7.65699L8.57908 15.4133L9.51409 12.4174H10.6335L9.10645 16.7495H8.05818ZM12.7883 16.798C12.1898 16.798 11.6818 16.6039 11.2612 16.2189C10.8439 15.8307 10.6335 15.2871 10.6335 14.5851C10.6335 14.1095 10.7403 13.7018 10.9571 13.3589C11.1706 13.0159 11.4424 12.7668 11.7756 12.6082C12.1088 12.4497 12.4744 12.3688 12.8789 12.3688C13.4418 12.3688 13.9012 12.5015 14.2571 12.7668C14.613 13.0353 14.833 13.4074 14.9172 13.8862L13.8268 14.1062C13.7815 13.8636 13.6715 13.6694 13.4968 13.5271C13.3221 13.3815 13.1118 13.3103 12.8691 13.3103C12.5294 13.3103 12.2577 13.4236 12.0474 13.6533C11.8403 13.883 11.7335 14.1936 11.7335 14.5851C11.7335 14.9766 11.8371 15.2872 12.0441 15.5169C12.2512 15.7434 12.5197 15.8598 12.8498 15.8598C13.1021 15.8598 13.3124 15.8016 13.4871 15.6819C13.6586 15.5654 13.7621 15.4101 13.7945 15.2225H12.7268V14.3553H14.8169V16.7495H13.8074V16.3677C13.7233 16.4971 13.5842 16.6039 13.3998 16.6815C13.2154 16.7592 13.0115 16.798 12.7883 16.798Z"
        fill="white"
      />
    </SVG>
  ),
  fileAudio: ({ otherTags = null, ...svgProps }) => (
    <SVG
      {...svgProps}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="24"
      viewBox="0 0 18 24"
      fill="none"
    >
      {otherTags}
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.14461 0H11.1767L17.9738 7.09489V20.873C17.9738 22.5985 16.5811 24 14.8556 24H3.14461C1.42782 24 0.0263672 22.5985 0.0263672 20.873V3.11824C0.0263369 1.40145 1.42782 0 3.14461 0Z"
        fill="#1B6EC2"
      />
      <path
        opacity="0.302"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.168 0V7.03358H17.9738L11.168 0Z"
        fill="white"
      />
      <path
        d="M6.0525 12.2978C6.81454 11.5446 7.8569 11.0803 9.00433 11.0803C10.1518 11.0803 11.1941 11.5446 11.9474 12.2978C12.7094 13.0511 13.1737 14.0935 13.1737 15.2321V17.0978C13.1737 17.3431 13.0773 17.5708 12.9109 17.7285C12.7532 17.8949 12.5255 17.9912 12.2802 17.9912H11.851V15.2671H12.3152V15.2321C12.3152 14.3299 11.9386 13.5066 11.343 12.9109C10.7386 12.3066 9.91523 11.9387 9.00429 11.9387C8.09333 11.9387 7.26121 12.3066 6.65686 12.9109C6.06124 13.5066 5.69335 14.3299 5.69335 15.2321V15.2671H6.15757V17.9912H5.72837C5.47435 17.9912 5.25538 17.8949 5.08896 17.7285C4.9313 17.5708 4.82617 17.3431 4.82617 17.0978V15.2321C4.82623 14.0935 5.29923 13.0511 6.0525 12.2978ZM10.4846 14.8029H10.7211C10.9051 14.8029 11.0715 14.8818 11.1854 14.9957C11.308 15.1183 11.3781 15.2847 11.3781 15.4687V17.7986C11.3781 17.9825 11.308 18.149 11.1854 18.2628C11.0715 18.3854 10.9051 18.4643 10.7211 18.4643H10.4846C10.362 18.4643 10.2569 18.4117 10.1781 18.3329C10.0992 18.2541 10.0554 18.149 10.0554 18.0263V15.2322C10.0554 15.1183 10.0992 15.0044 10.1781 14.9343C10.2569 14.8555 10.362 14.8029 10.4846 14.8029ZM7.28757 14.8029H7.5153C7.63793 14.8029 7.74303 14.8555 7.82187 14.9343C7.90072 15.0044 7.9445 15.1183 7.9445 15.2322V18.0263C7.9445 18.149 7.90072 18.2541 7.82187 18.3329C7.74303 18.4117 7.63793 18.4643 7.5153 18.4643H7.28757C7.10362 18.4643 6.9372 18.3854 6.81457 18.2628C6.69194 18.149 6.62186 17.9825 6.62186 17.7986V15.4687C6.62186 15.2847 6.69194 15.1183 6.81457 14.9957C6.9372 14.8818 7.10362 14.8029 7.28757 14.8029Z"
        fill="white"
      />
    </SVG>
  ),
  fileVideo: ({ otherTags = null, ...svgProps }) => (
    <SVG
      {...svgProps}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="24"
      viewBox="0 0 18 24"
      fill="none"
    >
      {otherTags}
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.14982 0H11.1738L17.9744 7.08846V20.8756C17.9744 22.6027 16.5771 24 14.8559 24H3.14982C1.42269 24 0.0253906 22.6027 0.0253906 20.8756V3.12443C0.0253603 1.3973 1.42266 0 3.14982 0Z"
        fill="#E03131"
      />
      <path
        opacity="0.302"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.168 0V7.03449H17.9746L11.168 0Z"
        fill="white"
      />
      <path
        d="M9.00312 10.8906C6.86218 10.8906 5.12305 12.6297 5.12305 14.7706C5.12305 16.9116 6.86218 18.6447 9.00312 18.6447C11.144 18.6447 12.8772 16.9115 12.8772 14.7706C12.8772 12.6297 11.138 10.8965 9.00312 10.8906ZM10.6343 14.8906C10.6043 14.9445 10.5623 14.9865 10.5084 15.0165L8.29548 16.1259C8.15753 16.1919 7.98963 16.1379 7.92367 16C7.89969 15.964 7.89368 15.922 7.89368 15.8741V13.6612C7.89368 13.5052 8.01962 13.3853 8.16954 13.3853C8.21151 13.3853 8.25351 13.3913 8.29548 13.4153L10.5084 14.5188C10.6463 14.5907 10.7003 14.7526 10.6343 14.8906Z"
        fill="white"
      />
    </SVG>
  ),
  filePowerpoint: ({ otherTags = null, ...svgProps }) => (
    <SVG
      {...svgProps}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="24"
      viewBox="0 0 18 24"
      fill="none"
    >
      {otherTags}
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.14982 0H11.1738L17.9744 7.08846V20.8756C17.9744 22.6027 16.5771 24 14.8559 24H3.14982C1.42269 24 0.0253906 22.6027 0.0253906 20.8756V3.12443C0.0253603 1.3973 1.42266 0 3.14982 0Z"
        fill="#E67700"
      />
      <path
        opacity="0.302"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.1675 0V7.03449H17.9741L11.1675 0Z"
        fill="white"
      />
      <path
        d="M3.79736 17.1694V12.8096H5.65043C6.1062 12.8096 6.47203 12.9355 6.74788 13.1934C7.01773 13.4453 7.15568 13.7811 7.15568 14.2069C7.15568 14.6267 7.01773 14.9685 6.74788 15.2204C6.47203 15.4722 6.1062 15.5982 5.65043 15.5982H4.9068V17.1694H3.79736ZM4.90682 14.6507H5.52452C5.69243 14.6507 5.81836 14.6147 5.91434 14.5367C6.00428 14.4587 6.04628 14.3448 6.04628 14.2069C6.04628 14.0629 6.00431 13.955 5.91434 13.877C5.81839 13.7991 5.69246 13.7571 5.52452 13.7571H4.90682V14.6507ZM7.62346 17.1694V12.8096H9.47652C9.93229 12.8096 10.2981 12.9355 10.574 13.1934C10.8498 13.4453 10.9818 13.7811 10.9818 14.2069C10.9818 14.6267 10.8498 14.9685 10.574 15.2204C10.2981 15.4722 9.93229 15.5982 9.47652 15.5982H8.73889V17.1694H7.62346ZM8.73889 14.6507H9.35058C9.51849 14.6507 9.65043 14.6147 9.7404 14.5367C9.83034 14.4587 9.87834 14.3448 9.87834 14.2069C9.87834 14.0629 9.83037 13.955 9.7404 13.877C9.65043 13.7991 9.51852 13.7571 9.35058 13.7571H8.73889V14.6507ZM12.583 17.1694V13.7571H11.3416V12.8096H14.9458V13.7571H13.6984V17.1694H12.583Z"
        fill="white"
      />
    </SVG>
  ),
  fileImage: ({ otherTags = null, ...svgProps }) => (
    <SVG
      {...svgProps}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="24"
      viewBox="0 0 18 24"
      fill="none"
    >
      {otherTags}
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.1495 0H11.1766L17.9757 7.09344V20.8744C17.9757 22.5996 16.5753 24 14.8501 24H3.1495C1.42435 24 0.0239258 22.5996 0.0239258 20.8744V3.12558C0.0239258 1.40042 1.42435 0 3.1495 0Z"
        fill="#40C057"
      />
      <path
        opacity="0.302"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.1665 0V7.03255H17.9758L11.1665 0Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.0492 11.9949H5.95031C5.49367 11.9949 5.11816 12.3704 5.11816 12.8271V16.7036C5.11816 17.1603 5.49364 17.5358 5.95031 17.5358H12.0492C12.5059 17.5358 12.8712 17.1603 12.8712 16.7036V12.8271C12.8712 12.3704 12.5059 11.9949 12.0492 11.9949ZM7.61458 13.0402C8.11183 13.0402 8.50759 13.4461 8.50759 13.9332C8.50759 14.4304 8.11183 14.8363 7.61458 14.8363C7.11733 14.8363 6.71141 14.4304 6.71141 13.9332C6.71141 13.4461 7.11733 13.0402 7.61458 13.0402ZM12.3233 16.7036C12.3233 16.8558 12.2015 16.9877 12.0492 16.9877H5.95031C5.79809 16.9877 5.67631 16.8558 5.67631 16.7036V16.5412L6.78243 15.4351L7.69576 16.3485C7.80738 16.4601 7.97989 16.4601 8.09152 16.3485L10.385 14.055L12.3233 15.9933V16.7036Z"
        fill="white"
      />
    </SVG>
  ),
  fileExcel: ({ otherTags = null, ...svgProps }) => (
    <SVG
      {...svgProps}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="24"
      viewBox="0 0 18 24"
      fill="none"
    >
      {otherTags}
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.14461 0H11.1767L17.9738 7.09489V20.873C17.9738 22.5985 16.5811 24 14.8556 24H3.14461C1.42782 24 0.0263672 22.5985 0.0263672 20.873V3.11824C0.0263369 1.40145 1.42782 0 3.14461 0Z"
        fill="#2B8A3E"
      />
      <path
        opacity="0.302"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.168 0V7.03358H17.9738L11.168 0Z"
        fill="white"
      />
      <path
        d="M7.48898 17.4745H6.32403L5.52697 16.1344L4.72987 17.4745H3.55615L4.94011 15.1446L3.7226 13.1212H4.89629L5.52694 14.1723L6.14882 13.1212H7.32254L6.11376 15.1533L7.48898 17.4745ZM7.90066 17.4745V13.1212H9.01307V16.5285H10.905V17.4745H7.90066V17.4745ZM12.7445 17.527C12.3065 17.527 11.9211 17.3869 11.5883 17.1154C11.2642 16.8526 11.0802 16.5197 11.054 16.1256L12.0087 15.8453C12.035 16.0555 12.1226 16.2395 12.2715 16.3796C12.4291 16.5198 12.6043 16.5898 12.797 16.5898C12.9547 16.5898 13.0861 16.5548 13.1912 16.4847C13.2875 16.4146 13.3401 16.3183 13.3401 16.2044C13.3401 16.1081 13.2963 16.0293 13.2175 15.9592C13.1386 15.8979 13.0335 15.8453 12.9109 15.8015C12.7882 15.7577 12.6394 15.7139 12.4904 15.6789C12.3328 15.6351 12.1751 15.5826 12.0262 15.5125C11.8685 15.4512 11.7284 15.3723 11.6058 15.276C11.4744 15.1884 11.378 15.057 11.2992 14.8906C11.2203 14.7329 11.1766 14.5402 11.1766 14.3212C11.1766 13.9621 11.3254 13.6643 11.632 13.4278C11.9386 13.1825 12.3065 13.0687 12.7357 13.0687C13.1649 13.0687 13.5415 13.1738 13.8568 13.3752C14.1722 13.5854 14.3736 13.857 14.4525 14.1898L13.4539 14.6103C13.4101 14.4263 13.3225 14.2774 13.1999 14.1636C13.0773 14.0585 12.9196 13.9972 12.7357 13.9972C12.5955 13.9972 12.4904 14.0322 12.4028 14.0848C12.324 14.1373 12.289 14.2162 12.289 14.3125C12.289 14.4001 12.3415 14.4789 12.4466 14.5402C12.5517 14.5928 12.6919 14.6366 12.8495 14.6629C13.0072 14.6891 13.1824 14.7329 13.3663 14.7942C13.559 14.8643 13.7254 14.9344 13.8919 15.0307C14.0495 15.1184 14.1809 15.2672 14.286 15.4599C14.3999 15.6614 14.4524 15.8979 14.4524 16.1694C14.4524 16.5724 14.2948 16.9052 13.9794 17.1504C13.6641 17.3957 13.2525 17.527 12.7445 17.527Z"
        fill="white"
      />
    </SVG>
  ),
  fileTxt: ({ otherTags = null, ...svgProps }) => (
    <SVG
      {...svgProps}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="24"
      viewBox="0 0 18 24"
      fill="none"
    >
      {otherTags}
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.14982 0H11.1738L17.9744 7.08846V20.8756C17.9744 22.6027 16.5771 24 14.8559 24H3.14982C1.42269 24 0.0253906 22.6027 0.0253906 20.8756V3.12443C0.0253603 1.3973 1.42266 0 3.14982 0Z"
        fill="#494949"
      />
      <path
        opacity="0.302"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.1675 0V7.03449H17.9741L11.1675 0Z"
        fill="white"
      />
      <path
        d="M4.5589 17.5229V14.1106H3.31152V13.1631H6.91574V14.1106H5.67436V17.5229H4.5589ZM10.9697 17.5229H9.8003L9.00269 16.1856L8.20508 17.5229H7.02966L8.41498 15.1961L7.2036 13.1631H8.37301L9.00269 14.2186L9.62639 13.1631H10.8018L9.59043 15.2021L10.9697 17.5229ZM12.325 17.5229V14.1106H11.0836V13.1631H14.6879V14.1106H13.4405V17.5229H12.325Z"
        fill="white"
      />
    </SVG>
  ),
  fileExternal: ({ otherTags = null, ...svgProps }) => (
    <SVG
      {...svgProps}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {otherTags}
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.14572 0H14.1728L20.9751 7.09007V20.8792C20.9751 22.5982 19.5733 24 17.8543 24H6.14572C4.41932 24 3.0249 22.5982 3.0249 20.8792V3.12082C3.0249 1.39442 4.41932 0 6.14572 0Z"
        fill="#FAB005"
      />
      <path
        opacity="0.302"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.1655 0V7.03106H20.9752L14.1655 0Z"
        fill="white"
      />
      <path
        d="M10.2674 18.061H9.31908C8.0097 18.061 6.94824 16.9995 6.94824 15.6902C6.94824 14.3808 8.0097 13.3193 9.31908 13.3193H10.2674M13.1124 18.061H14.0607C15.3701 18.061 16.4316 16.9995 16.4316 15.6902C16.4316 14.3808 15.3701 13.3193 14.0607 13.3193H13.1124M9.31908 15.6902L14.0607 15.6902"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SVG>
  ),
  folder: ({ otherTags = null, ...svgProps }) => (
    <SVG {...svgProps} viewBox="0 0 80 80">
      {otherTags}
      <path
        d="M36.4419 58.5286H10.9169C9.59073 58.5286 8.51562 57.4533 8.51562 56.1267V16.6958C8.51562 15.3693 9.59073 14.2939 10.9169 14.2939H36.4419C37.7681 14.2939 38.8432 15.3693 38.8432 16.6958V56.1267C38.8432 57.4533 37.7681 58.5286 36.4419 58.5286Z"
        fill="#2E70E2"
      />
      <path
        d="M68.9791 65.6291H10.9169C9.59065 65.6291 8.51562 64.5538 8.51562 63.2272V21.4488C8.51562 20.1223 9.59065 19.0469 10.9169 19.0469H68.9791C70.3053 19.0469 71.3804 20.1223 71.3804 21.4488V63.2272C71.3804 64.5538 70.3053 65.6291 68.9791 65.6291Z"
        fill="#E2EEF8"
      />
      <path
        d="M52.5615 38.5712H24.6159C24.2843 38.5712 24.0156 38.3024 24.0156 37.9708V36.9794C24.0156 36.6478 24.2843 36.3789 24.6159 36.3789H52.5615C52.8932 36.3789 53.1619 36.6478 53.1619 36.9794V37.9708C53.1619 38.3024 52.8932 38.5712 52.5615 38.5712Z"
        fill="#BEC6CC"
      />
      <path
        d="M21.3659 37.4749C21.3659 38.4995 20.5355 39.3301 19.511 39.3301C18.4867 39.3301 17.6562 38.4995 17.6562 37.4749C17.6562 36.4503 18.4867 35.6196 19.511 35.6196C20.5355 35.6196 21.3659 36.4503 21.3659 37.4749Z"
        fill="#BEC6CC"
      />
      <path
        d="M61.6427 45.7636H24.6159C24.2843 45.7636 24.0156 45.4948 24.0156 45.1631V44.1718C24.0156 43.8402 24.2843 43.5713 24.6159 43.5713H61.6427C61.9743 43.5713 62.243 43.8402 62.243 44.1718V45.1631C62.243 45.4948 61.9743 45.7636 61.6427 45.7636Z"
        fill="#BEC6CC"
      />
      <path
        d="M21.3659 44.6673C21.3659 45.6918 20.5355 46.5225 19.511 46.5225C18.4867 46.5225 17.6562 45.6918 17.6562 44.6673C17.6562 43.6426 18.4867 42.812 19.511 42.812C20.5355 42.812 21.3659 43.6426 21.3659 44.6673Z"
        fill="#BEC6CC"
      />
      <path
        d="M44.1489 52.9555H24.6159C24.2843 52.9555 24.0156 52.6867 24.0156 52.355V51.3637C24.0156 51.032 24.2843 50.7632 24.6159 50.7632H44.1489C44.4804 50.7632 44.7492 51.032 44.7492 51.3637V52.355C44.7492 52.6867 44.4804 52.9555 44.1489 52.9555Z"
        fill="#BEC6CC"
      />
      <path
        d="M21.3659 51.8596C21.3659 52.8843 20.5355 53.7149 19.511 53.7149C18.4867 53.7149 17.6562 52.8843 17.6562 51.8596C17.6562 50.8351 18.4867 50.0044 19.511 50.0044C20.5355 50.0044 21.3659 50.8351 21.3659 51.8596Z"
        fill="#BEC6CC"
      />
    </SVG>
  ),
  fullSizeDot: ({ otherTags = null, ...svgProps }) => (
    <SVG {...svgProps} viewBox="0 0 48 48">
      {otherTags}
      <g transform="matrix(6,0,0,6,-144,-144)">
        <circle cx="28" cy="28" r="4" />
      </g>
    </SVG>
  ),
  fullSizeSquare: ({ otherTags = null, ...svgProps }) => (
    <SVG {...svgProps} viewBox="0 0 48 48">
      {otherTags}
      <rect x="0" y="0" width="48" height="48" />
    </SVG>
  ),
  grayCalendar: ({ otherTags = null, ...svgProps }) => (
    <SVG {...svgProps} viewBox="0 0 1024 1024" fill="none">
      {otherTags}
      <path
        d="M105.288 893.795C91.3795 893.795 80 882.409 80 868.494V352.15H944V868.494C944 882.409 932.62 893.795 918.712 893.795H105.288Z"
        fill="#E4EBF7"
      />
      <path
        d="M944 357.192H80V229.367C80 215.407 91.311 204.092 105.263 204.092H918.737C932.69 204.092 944 215.407 944 229.367V357.192Z"
        fill="rgba(46, 112, 226, 0.8)"
      />
      <path
        d="M240.581 571.786C221.031 571.786 205.182 555.929 205.182 536.368C205.182 516.806 221.031 500.949 240.581 500.949C260.133 500.949 275.982 516.806 275.982 536.368C275.982 555.929 260.133 571.786 240.581 571.786Z"
        fill="#A3B5D6"
      />
      <path
        d="M464.529 536.368C464.529 555.929 448.68 571.786 429.128 571.786C409.578 571.786 393.729 555.929 393.729 536.368C393.729 516.806 409.578 500.949 429.128 500.949C448.68 500.949 464.529 516.806 464.529 536.368Z"
        fill="#A3B5D6"
      />
      <path
        d="M672.137 536.369C672.137 566.463 647.754 590.858 617.675 590.858C587.596 590.858 563.213 566.463 563.213 536.369C563.213 506.276 587.596 481.881 617.675 481.881C647.754 481.881 672.137 506.276 672.137 536.369Z"
        fill="white"
      />
      <path
        d="M653.076 536.368C653.076 555.929 637.227 571.786 617.675 571.786C598.124 571.786 582.275 555.929 582.275 536.368C582.275 516.806 598.124 500.949 617.675 500.949C637.227 500.949 653.076 516.806 653.076 536.368Z"
        fill="#2E70E2"
      />
      <path
        d="M841.623 536.368C841.623 555.929 825.774 571.786 806.222 571.786C786.671 571.786 770.822 555.929 770.822 536.368C770.822 516.806 786.671 500.949 806.222 500.949C825.774 500.949 841.623 516.806 841.623 536.368Z"
        fill="#A3B5D6"
      />
      <path
        d="M275.982 717.563C275.982 737.124 260.133 752.981 240.581 752.981C221.031 752.981 205.182 737.124 205.182 717.563C205.182 698.002 221.031 682.145 240.581 682.145C260.133 682.145 275.982 698.002 275.982 717.563Z"
        fill="#A3B5D6"
      />
      <path
        d="M464.529 717.563C464.529 737.124 448.68 752.981 429.128 752.981C409.578 752.981 393.729 737.124 393.729 717.563C393.729 698.002 409.578 682.145 429.128 682.145C448.68 682.145 464.529 698.002 464.529 717.563Z"
        fill="#A3B5D6"
      />
      <path
        d="M653.076 717.563C653.076 737.124 637.227 752.981 617.675 752.981C598.124 752.981 582.275 737.124 582.275 717.563C582.275 698.002 598.124 682.145 617.675 682.145C637.227 682.145 653.076 698.002 653.076 717.563Z"
        fill="#A3B5D6"
      />
      <path
        d="M841.623 717.563C841.623 737.124 825.774 752.981 806.222 752.981C786.671 752.981 770.822 737.124 770.822 717.563C770.822 698.002 786.671 682.145 806.222 682.145C825.774 682.145 841.623 698.002 841.623 717.563Z"
        fill="#A3B5D6"
      />
      <path
        d="M216.183 291.768C203.098 291.768 192.393 281.058 192.393 267.967V154.854C192.393 141.764 203.098 131.053 216.183 131.053C229.267 131.053 239.972 141.764 239.972 154.854V267.967C239.972 281.058 229.267 291.768 216.183 291.768Z"
        fill="#A3B5D6"
      />
      <path
        d="M806.85 291.768C793.766 291.768 783.061 281.058 783.061 267.967V154.854C783.061 141.764 793.766 131.053 806.85 131.053C819.934 131.053 830.64 141.764 830.64 154.854V267.967C830.64 281.058 819.934 291.768 806.85 291.768Z"
        fill="#A3B5D6"
      />
    </SVG>
  ),
  halfSizeDot: ({ otherTags = null, ...svgProps }) => (
    <SVG {...svgProps} viewBox="0 0 48 48">
      {otherTags}
      <g transform="matrix(3,0,0,3,-60,-60)">
        <circle cx="28" cy="28" r="4" />
      </g>
    </SVG>
  ),
  halfSizeSquare: ({ otherTags = null, ...svgProps }) => (
    <SVG {...svgProps} viewBox="0 0 48 48">
      {otherTags}
      <g transform="matrix(0.5,0,0,0.5,12,12)">
        <rect x="0" y="0" width="48" height="48" />
      </g>
    </SVG>
  ),
  hiResAvatar: ({ otherTags = null, fill = "white", ...svgProps }) => (
    <SVG
      {...svgProps}
      width="106"
      height="105"
      viewBox="0 0 106 105"
      fill="none"
    >
      {otherTags}
      <g>
        <path d="M105.488 105H0.513062V0H105.488V105Z" fill={fill} />
        <path
          d="M104.768 95.1723C104.768 95.1723 104.863 93.2647 98.854 90.593L70.2387 76.8543C70.2387 76.8543 66.2561 74.3997 66.0421 71.0343C66.0421 71.0343 65.2788 62.352 65.756 61.4934C65.756 61.4934 69.6425 55.5543 70.2147 49.9015C70.2147 49.9015 73.2192 50.4024 73.7201 44.7495C73.7201 44.7495 76.0809 36.3775 73.0048 37.3077C73.0048 37.3077 74.1495 21.9949 73.0048 19.7052C73.0048 19.7052 71.6098 13.3342 63.9194 9.25814C60.2591 7.31804 54.4111 7.23884 53.0012 7.24949C53.0009 7.24949 53.0006 7.24949 53.0003 7.24949C53 7.24949 52.9997 7.24949 52.9994 7.24949C51.5894 7.23884 45.7414 7.31804 42.081 9.25814C34.3907 13.3342 32.9956 19.7052 32.9956 19.7052C31.851 21.9949 32.9956 37.3077 32.9956 37.3077C29.9197 36.3775 32.2804 44.7495 32.2804 44.7495C32.7813 50.4024 35.7858 49.9015 35.7858 49.9015C36.3581 55.5543 40.2445 61.4934 40.2445 61.4934C40.7217 62.352 39.9584 71.0343 39.9584 71.0343C39.7442 74.3997 35.7618 76.8543 35.7618 76.8543L7.14657 90.593C1.13748 93.2647 1.23296 95.1723 1.23296 95.1723C0.18404 96.8898 0.568966 105 0.568966 105H53.0003H105.432C105.432 105 105.816 96.8898 104.768 95.1723Z"
          fill="#D4D8DC"
        />
      </g>
      <defs>
        <clipPath id="clip0_17492_331">
          <rect
            width="105"
            height="105"
            fill={fill}
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </SVG>
  ),
  inverseGrid: ({ otherTags = null, ...svgProps }) => (
    <SVG {...svgProps} viewBox="0 0 48 48">
      {otherTags}
      <rect x="5" y="5" width="10" height="10" />
      <rect x="19" y="5" width="10" height="10" />
      <rect x="33" y="5" width="10" height="10" />
      <rect x="5" y="19" width="10" height="10" />
      <rect x="19" y="19" width="10" height="10" />
      <rect x="33" y="19" width="10" height="10" />
      <rect x="5" y="33" width="10" height="10" />
      <rect x="19" y="33" width="10" height="10" />
      <rect x="33" y="33" width="10" height="10" />
    </SVG>
  ),
  linkedIn: ({ otherTags = null, ...svgProps }) => (
    <SVG {...svgProps} width="20" height="20" viewBox="0 0 20 20" fill="none">
      {otherTags}
      <rect width="20" height="20" rx="10" fill="#0A66C2" />
      <path
        d="M14.688 4.5H5.31201C5.09665 4.5 4.89012 4.58555 4.73783 4.73783C4.58555 4.89012 4.5 5.09665 4.5 5.31201V14.688C4.5 14.9033 4.58555 15.1099 4.73783 15.2622C4.89012 15.4144 5.09665 15.5 5.31201 15.5H14.688C14.9033 15.5 15.1099 15.4144 15.2622 15.2622C15.4144 15.1099 15.5 14.9033 15.5 14.688V5.31201C15.5 5.09665 15.4144 4.89012 15.2622 4.73783C15.1099 4.58555 14.9033 4.5 14.688 4.5ZM7.77861 13.8706H6.12479V8.61736H7.77861V13.8706ZM6.95056 7.88938C6.76296 7.88832 6.57988 7.83171 6.42442 7.72671C6.26896 7.6217 6.14809 7.47299 6.07707 7.29936C6.00604 7.12572 5.98805 6.93494 6.02535 6.75108C6.06265 6.56723 6.15358 6.39854 6.28665 6.26632C6.41973 6.13409 6.589 6.04425 6.77309 6.00813C6.95718 5.97201 7.14784 5.99123 7.32102 6.06337C7.4942 6.13551 7.64212 6.25733 7.74613 6.41346C7.85014 6.56958 7.90556 6.75303 7.90542 6.94063C7.90719 7.06622 7.88365 7.19089 7.83621 7.3072C7.78878 7.42351 7.71841 7.52908 7.6293 7.61761C7.5402 7.70615 7.43418 7.77584 7.31757 7.82253C7.20096 7.86922 7.07614 7.89195 6.95056 7.88938ZM13.8744 13.8752H12.2214V11.0053C12.2214 10.1589 11.8616 9.89764 11.3972 9.89764C10.9067 9.89764 10.4255 10.2674 10.4255 11.0267V13.8752H8.77167V8.62118H10.3621V9.34917H10.3835C10.5431 9.02604 11.1023 8.47375 11.9556 8.47375C12.8783 8.47375 13.8752 9.02146 13.8752 10.6256L13.8744 13.8752Z"
        fill="white"
      />
    </SVG>
  ),
  locationAlt: ({ otherTags = null, ...svgProps }) => (
    <SVG
      {...svgProps}
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {otherTags}
      <g id="location_on">
        <g id="Vector">
          <path
            d="M9.9974 1.66699C6.7724 1.66699 4.16406 4.27533 4.16406 7.50033C4.16406 11.8753 9.9974 18.3337 9.9974 18.3337C9.9974 18.3337 15.8307 11.8753 15.8307 7.50033C15.8307 4.27533 13.2224 1.66699 9.9974 1.66699ZM5.83073 7.50033C5.83073 5.20033 7.6974 3.33366 9.9974 3.33366C12.2974 3.33366 14.1641 5.20033 14.1641 7.50033C14.1641 9.90033 11.7641 13.492 9.9974 15.7337C8.26406 13.5087 5.83073 9.87533 5.83073 7.50033Z"
            fill="#494949"
          />
          <path
            d="M9.9974 9.58366C11.148 9.58366 12.0807 8.65092 12.0807 7.50033C12.0807 6.34973 11.148 5.41699 9.9974 5.41699C8.8468 5.41699 7.91406 6.34973 7.91406 7.50033C7.91406 8.65092 8.8468 9.58366 9.9974 9.58366Z"
            fill="#494949"
          />
        </g>
      </g>
    </SVG>
  ),
  none: ({ otherTags = null, ...svgProps }) => (
    <SVG {...svgProps} viewBox="0 0 48 48">
      {otherTags}
    </SVG>
  ),
  peopleAlt: ({ otherTags = null, ...svgProps }) => (
    <SVG {...svgProps} width="16" height="16" viewBox="0 0 16 16" fill="none">
      {otherTags}
      <path
        d="M11.1107 8.75366C12.0241 9.37366 12.6641 10.2137 12.6641 11.3337V13.3337H15.3307V11.3337C15.3307 9.88032 12.9507 9.02033 11.1107 8.75366Z"
        fill="#494949"
      />
      <path
        d="M9.9974 8.00033C11.4707 8.00033 12.6641 6.80699 12.6641 5.33366C12.6641 3.86033 11.4707 2.66699 9.9974 2.66699C9.68406 2.66699 9.39073 2.73366 9.11073 2.82699C9.66406 3.51366 9.9974 4.38699 9.9974 5.33366C9.9974 6.28033 9.66406 7.15366 9.11073 7.84033C9.39073 7.93366 9.68406 8.00033 9.9974 8.00033Z"
        fill="#494949"
      />
      <path
        d="M5.9974 8.00033C7.47073 8.00033 8.66406 6.80699 8.66406 5.33366C8.66406 3.86033 7.47073 2.66699 5.9974 2.66699C4.52406 2.66699 3.33073 3.86033 3.33073 5.33366C3.33073 6.80699 4.52406 8.00033 5.9974 8.00033ZM5.9974 4.00033C6.73073 4.00033 7.33073 4.60033 7.33073 5.33366C7.33073 6.06699 6.73073 6.66699 5.9974 6.66699C5.26406 6.66699 4.66406 6.06699 4.66406 5.33366C4.66406 4.60033 5.26406 4.00033 5.9974 4.00033Z"
        fill="#494949"
      />
      <path
        d="M5.9974 8.66699C4.2174 8.66699 0.664062 9.56033 0.664062 11.3337V13.3337H11.3307V11.3337C11.3307 9.56033 7.7774 8.66699 5.9974 8.66699ZM9.9974 12.0003H1.9974V11.3403C2.13073 10.8603 4.1974 10.0003 5.9974 10.0003C7.7974 10.0003 9.86406 10.8603 9.9974 11.3337V12.0003Z"
        fill="#494949"
      />
    </SVG>
  ),
  quarterSizeSquare: ({ otherTags = null, ...svgProps }) => (
    <SVG {...svgProps} viewBox="0 0 48 48">
      {otherTags}
      <g transform="matrix(0.25,0,0,0.25,18,18)">
        <rect x="0" y="0" width="48" height="48" />
      </g>
    </SVG>
  ),
  quarterSizeDot: ({ otherTags = null, ...svgProps }) => (
    <SVG {...svgProps} viewBox="0 0 48 48">
      {otherTags}
      <g transform="matrix(1.5,0,0,1.5,-18,-18)">
        <circle cx="28" cy="28" r="4" />
      </g>
    </SVG>
  ),
  searchFolder: ({ otherTags = null, ...svgProps }) => (
    <SVG {...svgProps} viewBox="0 0 80 80">
      {otherTags}
      <path
        d="M34.822 26.994h-1.046l-.361-.358a8.32 8.32 0 0 0 2.064-5.495c0-4.669-3.826-8.453-8.547-8.453-4.72 0-8.547 3.784-8.547 8.453 0 4.67 3.826 8.454 8.547 8.454a8.55 8.55 0 0 0 5.556-2.035l.361    .358v1.027l6.575 6.49 1.96-1.938-6.562-6.503zm-7.89 0c-3.268 0-5.917-2.62-5.917-5.853 0-3.232 2.65-5.852 5.917-5.852 3.268 0 5.918 2.62 5.918 5.852s-2.65 5.853-5.918 5.853z"
        fill="#000"
      />
      <path
        d="M16.932 3.857H30.22c1.836 0 3.322 1.47 3.322 3.286v5.786a10.795 10.795 0 0 0-3.322-1.393V7.143H3.645V23.57h13.414a10.494 10.494 0 0 0 1.09 3.286H3.644c-1.836 0-3.323-1.47-3.323-3.286L.34     3.857A3.288 3.288 0 0 1 3.645.57h9.966l3.32 3.286z"
        fill="#000"
      />
    </SVG>
  ),
  threeQuarterSizeDot: ({ otherTags = null, ...svgProps }) => (
    <SVG {...svgProps} viewBox="0 0 48 48">
      {otherTags}
      <g transform="matrix(4.5,0,0,4.5,-102,-102)">
        <circle cx="28" cy="28" r="4" />
      </g>
    </SVG>
  ),
  tipsAndUpdates: ({}) => (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none">
      <rect width="16" height="17" fill="#F5F5F5" />
      <g id="Sessions">
        <path
          d="M-3258 -574C-3258 -575.105 -3257.1 -576 -3256 -576H7605C7606.1 -576 7607 -575.105 7607 -574V3307C7607 3308.1 7606.1 3309 7605 3309H-3256C-3257.1 3309 -3258 3308.1 -3258 3307V-574Z"
          fill="black"
        />
        <path
          d="M-3256 -575H7605V-577H-3256V-575ZM7606 -574V3307H7608V-574H7606ZM7605 3308H-3256V3310H7605V3308ZM-3257 3307V-574H-3259V3307H-3257ZM-3256 3308C-3256.55 3308 -3257 3307.55 -3257 3307H-3259C-3259 3308.66 -3257.66 3310 -3256 3310V3308ZM7606 3307C7606 3307.55 7605.55 3308 7605 3308V3310C7606.66 3310 7608 3308.66 7608 3307H7606ZM7605 -575C7605.55 -575 7606 -574.552 7606 -574H7608C7608 -575.657 7606.66 -577 7605 -577V-575ZM-3256 -577C-3257.66 -577 -3259 -575.657 -3259 -574H-3257C-3257 -574.552 -3256.55 -575 -3256 -575V-577Z"
          fill="black"
          fill-opacity="0.1"
        />
        <g id="Portal/Sessions" clip-path="url(#clip0_7161_4324)">
          <rect
            width="1440"
            height="800"
            transform="translate(-136 -81)"
            fill="white"
          />
          <g id="Content scroll">
            <g id="Frame 427326227">
              <g id="Session Card Portal">
                <rect
                  x="-19.5"
                  y="-17.5"
                  width="807"
                  height="190"
                  rx="7.5"
                  fill="white"
                />
                <rect
                  x="-19.5"
                  y="-17.5"
                  width="807"
                  height="190"
                  rx="7.5"
                  stroke="#4263EB"
                />
                <g id="Session Card Cell/Top">
                  <g id="Session Name&#38;Event">
                    <g id="Session Name">
                      <g id="Frame 427325786">
                        <g
                          id="tips_and_updates_24dp 1"
                          clip-path="url(#clip1_7161_4324)"
                        >
                          <path
                            id="Vector"
                            d="M4.66667 13.8333H7.33333C7.33333 14.5667 6.73333 15.1667 6 15.1667C5.26667 15.1667 4.66667 14.5667 4.66667 13.8333ZM3.33333 13.1667H8.66667V11.8333H3.33333V13.1667ZM11 6.83333C11 9.38 9.22667 10.74 8.48667 11.1667H3.51333C2.77333 10.74 1 9.38 1 6.83333C1 4.07333 3.24 1.83333 6 1.83333C8.76 1.83333 11 4.07333 11 6.83333ZM9.66667 6.83333C9.66667 4.81333 8.02 3.16667 6 3.16667C3.98 3.16667 2.33333 4.81333 2.33333 6.83333C2.33333 8.48 3.32667 9.42667 3.9 9.83333H8.1C8.67333 9.42667 9.66667 8.48 9.66667 6.83333ZM14.2467 5.41333L13.3333 5.83333L14.2467 6.25333L14.6667 7.16667L15.0867 6.25333L16 5.83333L15.0867 5.41333L14.6667 4.5L14.2467 5.41333ZM12.6667 4.5L13.2933 3.12667L14.6667 2.5L13.2933 1.87333L12.6667 0.5L12.04 1.87333L10.6667 2.5L12.04 3.12667L12.6667 4.5Z"
                            fill="#FF922B"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_7161_4324">
          <rect
            width="1440"
            height="800"
            fill="white"
            transform="translate(-136 -81)"
          />
        </clipPath>
        <clipPath id="clip1_7161_4324">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  threeQuarterSizeSquare: ({ otherTags = null, ...svgProps }) => (
    <SVG {...svgProps} viewBox="0 0 48 48">
      {otherTags}
      <g transform="matrix(0.75,0,0,0.75,6,6)">
        <rect x="0" y="0" width="48" height="48" />
      </g>
    </SVG>
  ),
  twitter: ({ otherTags = null, ...svgProps }) => (
    <SVG {...svgProps} width="20" height="20" viewBox="0 0 20 20" fill="none">
      {otherTags}
      <g id="Group">
        <path
          id="Vector"
          d="M19.9986 10.0004C19.9986 15.051 16.2549 19.2264 11.3915 19.904C10.9368 19.9671 10.4716 20 9.9993 20C9.45417 20 8.91886 19.9566 8.39756 19.8725C3.63649 19.1059 0 14.9774 0 10.0004C0 4.47746 4.4773 0 10 0C15.5227 0 20 4.47746 20 10.0004H19.9986Z"
          fill="#1C1C1B"
        />
        <g id="layer1">
          <path
            id="path1009"
            d="M4.05217 4.41016L8.66399 10.5763L4.02344 15.5898H5.06814L9.13134 11.2006L12.414 15.5898H15.9685L11.0974 9.0768L15.4171 4.41016H14.3724L10.6308 8.45248L7.60738 4.41016H4.05286H4.05217ZM5.58804 5.17952H7.22061L14.4312 14.8204H12.7987L5.58804 5.17952Z"
            fill="white"
          />
        </g>
      </g>
    </SVG>
  ),
  work: ({ otherTags = null, ...svgProps }) => (
    <SVG {...svgProps} height="20" viewBox="0 0 20 20" fill="none">
      {otherTags}
      <g id="work_outline">
        <path
          id="Vector"
          d="M11.6641 5.41634V3.74967H8.33073V5.41634H11.6641ZM3.33073 7.08301V16.2497H16.6641V7.08301H3.33073ZM16.6641 5.41634C17.5891 5.41634 18.3307 6.15801 18.3307 7.08301V16.2497C18.3307 17.1747 17.5891 17.9163 16.6641 17.9163H3.33073C2.40573 17.9163 1.66406 17.1747 1.66406 16.2497L1.6724 7.08301C1.6724 6.15801 2.40573 5.41634 3.33073 5.41634H6.66406V3.74967C6.66406 2.82467 7.40573 2.08301 8.33073 2.08301H11.6641C12.5891 2.08301 13.3307 2.82467 13.3307 3.74967V5.41634H16.6641Z"
          fill="#494949"
        />
      </g>
    </SVG>
  )
};

export { lenndSVGs };
